import { VariableType } from 'json-to-graphql-query';
import { AssetNodeTypeNoPerms } from 'src/dynamoQueries/assets';
import { CollectionNodeType } from 'src/dynamoQueries/collections';
import type { FieldValue } from './types';

interface SharedAssetQueryResult {
  query: {
    __variables: {
      id: 'ID!';
    };
    sharedAsset: ReturnType<typeof AssetNodeTypeNoPerms> & {
      __args: {
        id: VariableType;
      };
    };
  };
}

interface SharedCollectionQueryResult {
  query: {
    __variables: {
      id: 'ID!';
      before: 'String';
      after: 'String';
      first: 'Int';
      last: 'Int';
      sequence: 'Int';
      orderBy: 'String';
      customOrder: 'String';
      collection_Name: 'String';
    };
    sharedCollection: ReturnType<typeof CollectionNodeType> & {
      __args: {
        id: VariableType;
      };
    };
  };
}

interface BasicSharedLinkInfoQueryResult {
  query: {
    __variables: {
      linkId: 'String!';
    };
    basicSharedLinkInfo: {
      __args: {
        linkId: VariableType;
      };
      id: FieldValue;
      expired: FieldValue;
      password: FieldValue;
      views: FieldValue;
      viewLimit: FieldValue;
    };
  };
}

interface SharedLinkMetadataMutationResult {
  mutation: {
    __variables: {
      linkId: 'String!';
      password: 'String';
    };
    accessSharedLinkMetadata: {
      __args: {
        linkId: VariableType;
        password: VariableType;
      };
      sharedLinkMetadata: {
        id: FieldValue;
        assetId: FieldValue;
        collectionId: FieldValue;
        downloadable: FieldValue;
        expirationDatetime: FieldValue;
        views: FieldValue;
        viewLimit: FieldValue;
      };
    };
  };
}

export const SharedAsset = (truify: boolean = false): SharedAssetQueryResult => ({
  query: {
    __variables: {
      id: 'ID!',
    },
    sharedAsset: {
      __args: {
        id: new VariableType('id'),
      },
      ...AssetNodeTypeNoPerms(truify),
    },
  },
});

export const SharedCollection = (truify: boolean = false): SharedCollectionQueryResult => ({
  query: {
    __variables: {
      id: 'ID!',
      before: 'String',
      after: 'String',
      first: 'Int',
      last: 'Int',
      sequence: 'Int',
      orderBy: 'String',
      customOrder: 'String',
      collection_Name: 'String',
    },
    sharedCollection: {
      __args: {
        id: new VariableType('id'),
      },
      ...CollectionNodeType(truify),
    },
  },
});

export const basicSharedLinkInfo = (truify: boolean = false): BasicSharedLinkInfoQueryResult => ({
  query: {
    __variables: {
      linkId: 'String!',
    },
    basicSharedLinkInfo: {
      __args: {
        linkId: new VariableType('linkId'),
      },
      id: truify,
      expired: true,
      password: true,
      views: truify,
      viewLimit: truify,
    },
  },
});

export const sharedLinkMetadata = (truify: boolean = false): SharedLinkMetadataMutationResult => ({
  mutation: {
    __variables: {
      linkId: 'String!',
      password: 'String',
    },
    accessSharedLinkMetadata: {
      __args: {
        linkId: new VariableType('linkId'),
        password: new VariableType('password'),
      },
      sharedLinkMetadata: {
        id: truify,
        assetId: true,
        collectionId: true,
        downloadable: true,
        expirationDatetime: truify,
        views: truify,
        viewLimit: truify,
      },
    },
  },
});
